'use strict';

var nonNegativeInteger = require('../../../_virtual/nonNegativeInteger.js_commonjs-exports.js');
require('./and.js');
require('./integer.js');
require('./nonNegativeNumber.js');
var integer = require('../../../_virtual/integer.js_commonjs-exports.js');
var nonNegativeNumber = require('../../../_virtual/nonNegativeNumber.js_commonjs-exports.js');
var and = require('../../../_virtual/and.js_commonjs-exports.js');

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _and = _interopRequireDefault(and.__exports);

var _integer = _interopRequireDefault(integer.__exports);

var _nonNegativeNumber = _interopRequireDefault(nonNegativeNumber.__exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = (0, _and["default"])([(0, _integer["default"])(), (0, _nonNegativeNumber["default"])()], 'nonNegativeInteger');

exports["default"] = _default;

}(nonNegativeInteger.__exports));
